import { MedicalService } from '../medical-services/medical-service';

const camelcaseKeysDeep = require('camelcase-keys-deep');

export class NurseVisit {
  id: string;
  patientName: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  phone1: string;
  providerNotes: string;
  patientConfirmed: boolean;
  nurseAccepted: boolean;
  selectionDefault: boolean;
  createdDate: Date;
  updatedDate: Date;
  services: MedicalService[];
  visit: string;
  provider: any;
  workpathId: string;

  constructor(data: any) {
    data = camelcaseKeysDeep(data);

    this.id = data.id;
    this.patientName = data.patientName;
    this.address1 = data.address1;
    this.address2 = data.address2;
    this.city = data.city;
    this.state = data.state;
    this.zip = data.zip;
    this.phone1 = data.phone1;
    this.providerNotes = data.providerNotes || '';
    this.patientConfirmed = data.patientConfirmed;
    this.nurseAccepted = data.nurseAccepted;
    this.selectionDefault = data.selectionDefault;
    this.createdDate = data.createdDate;
    this.updatedDate = data.updatedDate;
    this.services = data.services && data.services.map(service => {
      return new MedicalService(service);
    }) || [];
    this.visit = data.visit;
    this.provider = data.provider;
    this.workpathId = data.workpathId;
  }
}



// WEBPACK FOOTER //
// ./src/app/nurse-visits/nurse-visit.ts